import { useMemo } from 'react'
import { useConfigurationContext } from '@nv/contexts'
import { useCurrentTime } from '@nv/hooks'
import DividerIcon from '@nv/images/design/divider-icon'
import clsx from 'clsx'
import { CurrentTime } from '../../current_time/CurrentTime'
import LanguagesDropdown from '../../languages_dropdown/LanguagesDropdown'
import LogoutButton from '../../logout_btn/LogoutBtn'
import { SessionTimer } from '../../session_timer/SessionTimer'
import { Hamburger } from './components/hamburger/Hamburger'
import WelcomeMessage from './components/welcome_message/WelcomeMessage'
import styles from './TopBar.module.scss'

export function TopBar({
  noAuthentication = false,
  logo,
  links,
  className,
  mobileLogo,
  disableSessionExtension = false,
  showCurrentTime,
}: any) {
  const { languages } = useConfigurationContext()
  const renderLanguagesDropdown = useMemo(() => <LanguagesDropdown />, [])
  const currentTime = useCurrentTime()

  return (
    <div className={clsx(styles['container'], styles[className])}>
      <span className={styles['logo']}>{mobileLogo}</span>
      {!showCurrentTime && <CurrentTime time={currentTime} />}
      {!noAuthentication ? <SessionTimer disableSessionExtension={disableSessionExtension} /> : <div style={{ margin: 'auto' }} />}
      <div className={styles['btn-container']}>
        {languages && renderLanguagesDropdown}
        {!noAuthentication && (
          <>
            <DividerIcon style={{ marginRight: '1.25rem' }} />
            <div className={styles['welcome']}>
              <WelcomeMessage />
            </div>
            <div className={styles['divider-container']}>
              <DividerIcon style={{ marginRight: '1.25rem', marginLeft: '1.25rem' }} />
            </div>
            <LogoutButton />
          </>
        )}
      </div>
      <div className={styles['hamburger']}>
        <Hamburger links={links} logo={logo} showCurrentTime={showCurrentTime} />
      </div>
    </div>
  )
}
